import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
  animatedListWidget();
});

function scrollToNextElementorSection(currentSection) {
  const next = currentSection.parents('.elementor-element').next();
  if (next.length) {
    lockWheel();
    $('html, body').animate(
      {
        scrollTop: next.offset().top - 80,
      },
      600
    );
  }
}

//eslint-disable-next-line no-unused-vars
let wheelLocked = false;
const lockWheel = (time = 600) => {
  wheelLocked = true;
  setTimeout(() => (wheelLocked = false), time);
};
function animatedListWidget() {
  $('.js-animated-list').each(function () {
    const $section = $(this);
    const $list = $section.find('.animated-list');
    const targets = $list.find('.list-item');
    const perSlideScroll = 400;
    const endValue = targets.length * perSlideScroll;

    gsap.set($list, { autoAlpha: 1 });

    const timeline = gsap.timeline({
      defaults: {
        overwrite: 'auto',
      },
      scrollTrigger: {
        start: 'center center',
        end: `+=${endValue}`,
        pin: true,
        pinSpacing: true,
        scrub: true,
        trigger: $section,
        onLeave: () => {
          scrollToNextElementorSection($section);
        },
      },
    });
    if (!wheelLocked) {
      timeline.set(targets, { transformOrigin: 'top center' });

      timeline
        .from(targets, {
          duration: 1,
          opacity: 0,
          rotationX: 0,
          rotationY: 0,
          scale: 0.75,
          stagger: 1.2,
          y: 80,
        })
        .to(
          targets,
          {
            duration: 1,
            opacity: 0,
            rotationX: 0,
            rotationY: 0,
            scale: 0.75,
            stagger: 1.2,
            y: -80,
          },
          1.2
        );
    }
  });
}
